import { Component } from 'react';
import PropTypes from 'prop-types';

import Input from 'components/atoms/input/index.jsx';
import Label from 'components/atoms/label/index.jsx';
import classnames from 'classnames';
import classBind from 'classnames/bind';
import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FormTextField extends Component {
  render() {
    let {
      label,
      type,
      readonly,
      inline,
      size,
      noborder,
      icon,
      center,
      input,
      meta,
      helpText,
      ...etc
    } = this.props;
    readonly = readonly || '';

    input = input || {};

    meta = meta || {};

    let className = cx({
      formTextField: true,
      inline: inline,
      [`${size}`]: size,
      noborder: noborder,
      [`${icon}`]: icon,
      icon: icon,
      center: center,
    });

    return (
      <div className={classnames(className)}>
        {label && <Label label={label} />}

        {!readonly && <Input type={type} input={input} meta={meta} {...etc} />}
        {readonly && <Input type={type} meta={meta} readonly {...etc} />}
        {this.props.helpText && <div className="helpText">{this.props.helpText}</div>}
      </div>
    );
  }
}

FormTextField.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
};
